import {
  Beneficiary,
  TerminateContractInput,
} from '../../../../common/validations'
import { FormValues } from '../TerminateForm/initialValues'
import { ISODateFromLocaleDate } from '../../../utils'

export const formatFormValues = (
  formValues: FormValues,
  clearEmptyBeneficiaries: boolean = true,
  beneficiaries: Beneficiary[] = []
) => {
  const { files, newAddress, ...values } = formValues
  const {
    firstPossibleEndDate: _firstPossibleEndDate,
    lastPossibleEndDate: _lastPossibleEndDate,
    currentDate: _currentDate,
    propertyCompanyName: _propertyCompanyName,
    propertyCompanyAddress: _propertyCompanyAddress,
    movingDestination,
    presenterTenantUuid,
    ...otherValues
  } = values

  const isAddressProvided =
    newAddress &&
    Object.values(newAddress).some((value) => value && value.trim() !== '')

  return {
    ...otherValues,
    ...(movingDestination ? { movingDestination } : {}),
    presenterTenantUuid: formValues.displaysSelf
      ? presenterTenantUuid
      : undefined,
    movingOutDate: formValues.movingOutDate
      ? ISODateFromLocaleDate(formValues.movingOutDate)
      : null,
    beneficiaries: formValues.beneficiaries
      .filter((beneficiary) => {
        const {
          beneficiaryName,
          iban,
          removeExistingBeneficiary,
          existingBeneficiaryId,
        } = beneficiary

        if (!clearEmptyBeneficiaries) return true
        if (removeExistingBeneficiary) return true

        const hasName = !!beneficiaryName?.trim()
        const hasIban = !!iban?.trim()

        // Keep existing beneficiaries even if cleared (they'll be marked for removal in map)
        if (existingBeneficiaryId && !hasName && !hasIban) return true

        // Filter out new beneficiaries where both name and IBAN are empty
        return hasName || hasIban
      })
      .map(({ bankCountryCode: _bankCountryCode, ...beneficiary }) => {
        const hasName = !!beneficiary.beneficiaryName?.trim()
        const hasIban = !!beneficiary.iban?.trim()

        const isClearedExistingBeneficiary =
          beneficiary.existingBeneficiaryId &&
          !hasName &&
          !hasIban &&
          !beneficiary.removeExistingBeneficiary

        const existingDeletedBeneficiary =
          beneficiary.existingBeneficiaryId &&
          (beneficiary.removeExistingBeneficiary ||
            isClearedExistingBeneficiary)
            ? beneficiaries.find(
                (b) => b.id === beneficiary.existingBeneficiaryId
              )
            : undefined

        return {
          ...beneficiary,
          beneficiaryName: existingDeletedBeneficiary
            ? existingDeletedBeneficiary.beneficiaryName
            : beneficiary.beneficiaryName || null,
          iban: existingDeletedBeneficiary
            ? existingDeletedBeneficiary.iban
            : beneficiary.iban?.replace(/\s/g, '') || null,
          bic: existingDeletedBeneficiary
            ? existingDeletedBeneficiary.bic
            : beneficiary.bic?.replace(/\s/g, '') || null,
          removeExistingBeneficiary: !!existingDeletedBeneficiary,
          email: beneficiary.email || null,
          phoneNumber:
            beneficiary.phoneNumber?.replace(/[\s\-()]/g, '') || null,
          returnPercentage: beneficiary.returnPercentage
            ? beneficiary.returnPercentage
            : 0,
          rooReturnPercentage: beneficiary.rooReturnPercentage,
        }
      }),
    newAddress: isAddressProvided ? newAddress : undefined,
    fileUuids: files.map((file) => file.uuid),
  } as TerminateContractInput
}
